import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

type Props = {
  /** 件数表示テキスト */
  count?: number;
  /** 新規作成ボタンのツールチップ */
  createLabel?: string;
  /** 新規作成ボタンを表示するか */
  showCreate?: boolean;
};

/**
 * ガイド画面で表示用のモックリストヘッダー（件数 + 新規作成アイコンボタン）。
 * 実際のConditionListのListPanel上部を再現する。
 */
const GuideMockListHeader: React.FC<Props> = ({
  count = 5,
  createLabel = '新規作成',
  showCreate = true,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 0.5,
        pointerEvents: 'none',
      }}
    >
      <Typography variant="caption" color="text.secondary" fontWeight={500}>
        {count} 件
      </Typography>
      {showCreate && (
        <IconButton size="small" aria-label={createLabel}>
          <AddIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default GuideMockListHeader;
